import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const apiUrl = environment.apiUrl;

export interface GlobalSearchResult {
  appId: string | null;
  sysId: string | null;
  name: string | null;
  outcome: string | null;
  trackedBusinessApplicationId: number;
  modernizationAssessmentId: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  constructor(private http: HttpClient) {}

  search(term: string): Observable<GlobalSearchResult[]> {
    const params = new HttpParams().set('q', term);
    return this.http.get<GlobalSearchResult[]>(`${apiUrl}/dashboard/search`, { params });
  }

  /** Returns a debounced observable that fires after 300 ms and only when term length >= 2. */
  searchWithDebounce(term$: Observable<string>): Observable<GlobalSearchResult[]> {
    return term$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(term => term.length >= 2),
      switchMap(term => this.search(term))
    );
  }
}
